export default [
  {
    title: "Dashboard",
    icon: "HomeIcon",
    route: "dashboard",
    resource: "Invoice",
    action: "manage",
  },
];
